import angular from "angular";

angular
    .module('app')
    .component('coursesControl', {
        template: require('./courses-control.html'),
        controller: ['$uibModal', 'Notifier', '$http', '$timeout', 'Auth', controller],
        bindings: {
            categories: '<'
        }
    });

function controller($uibModal, Notifier, $http, $timeout, Auth) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.search = null;
    $ctrl.category = null;

    $ctrl.orderBy = 'id';
    $ctrl.orderDir = 'desc';

    $ctrl.$onInit = function () {
        $ctrl.user = Auth.user();

        $ctrl.getList();
    };

    $ctrl.getList = function () {
        $http
            .get('/admin/courses/get-list', {
                params: {
                    page: $ctrl.page,
                    search: $ctrl.search,
                    order_by:$ctrl.orderBy,
                    order_dir:$ctrl.orderDir,
                    category_id: $ctrl.category ? $ctrl.category.id : null
                }
            })
            .then(
                function (response) {
                    $ctrl.courses = response.data.data;
                    $ctrl.total = response.data.total;
                },
                function (error) {
                    console.log(error);
                }
            );
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.reset = function () {
        $ctrl.page = 1;
        $ctrl.search = null;
        $ctrl.category = null;
        $ctrl.getList();
    };

    $ctrl.setOrderBy = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.openCreateForm = function () {
        $uibModal
            .open({
                component: 'courseCreateForm',
                resolve: {
                    categories: function () {
                        return $ctrl.categories
                    }
                }
            })
            .result
            .then(
                function (course) {
                    $timeout(function () {
                        window.location = `/admin/courses/${course.id}/edit`;
                    }, 1000);
                }
            );
    };

    $ctrl.openPriorityModal = function (course) {
        $uibModal
            .open({
                component: 'coursePriorityModal',
                resolve: {
                    course: function () {
                        return course;
                    }
                }
            })
            .result
            .then(
                function (response) {
                    course.priority = response.priority;
                }
            );
    }

}
